import { AsyncResult, Result } from '../../assets/src/utils/Result';
import { loadScript } from '../../assets/src/utils/net/load-script';

export interface IPlatformPreloader {
	// TODO remove this and use complete deferred instead
	initialized: boolean;

	loadAndInit(): Promise<Result>;

	setLoadingProgress(progress: number): void;
}

export function stringifyValue(value: unknown): string {
	if (typeof value === 'string') {
		return value;
	}

	try {
		return JSON.stringify(value);
	} catch (e) {
		return 'error';
	}
}

// TODO allow to specify fallback url
export async function loadScriptWithRetries(url: string, maxAttempts = 3, attempt = 1): AsyncResult {
	console.log(`platform script load#${attempt} - start (${url})`);

	const loadResult = await loadScript(url);
	if (loadResult.success === true) {
		console.log(`platform script load#${attempt} - complete`);
		return AsyncResult.Ok();
	}

	console.warn(`platform script load#${attempt} - failed (${loadResult.error.message})`);

	const isLastAttempt = attempt === maxAttempts;
	if (isLastAttempt) {
		return AsyncResult.Error(loadResult.error.message);
	}

	return loadScriptWithRetries(url, maxAttempts, attempt + 1);
}
